export type Pass = {
  pass?: string;
  updateFlg?: boolean;
};

export type AuthUser = {
  uid: string;
  photoUrl: string;
  displayName: string;
  email: string;
  tenantId?: string;
};

export const newAuthUser = (): AuthUser & Pass => {
  return {
    uid: "",
    photoUrl: "",
    displayName: "",
    email: "",
    tenantId: ""
  };
};
